module.exports = __webpack_public_path__ + "static/media/gournet.3d0059c8.jpg";